export default __webpack_public_path__ + "static/media/logoBST.de2ae2ea.png";